// extracted by mini-css-extract-plugin
export default {"wrapper":"za","dark":"Aa","lead":"Ba","blinking":"Ca","gradientShift":"Da","float":"Ea","move":"Fa","scroll":"Ga"};